/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceUnitPriceCheapestSkuResponse {
    getFixupPrototypeFunction() { return ResourceUnitPriceCheapestSkuResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourceUnitPriceCheapestSkuResponse>): ResourceUnitPriceCheapestSkuResponse {
        let obj = Object.assign(new ResourceUnitPriceCheapestSkuResponse(), model);
        ResourceUnitPriceCheapestSkuResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceUnitPriceCheapestSkuResponse>): ResourceUnitPriceCheapestSkuResponse {
        if (!model) return null;
        return ResourceUnitPriceCheapestSkuResponse.newInstance(<ResourceUnitPriceCheapestSkuResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceUnitPriceCheapestSkuResponse) {
        if (!obj) return;

        models.ResourceUnitPriceCheapestSkuResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceUnitPriceCheapestSkuResponse): boolean {
        Object.setPrototypeOf(obj, ResourceUnitPriceCheapestSkuResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.daily_cost === undefined) {
            this.daily_cost = 0;
        }
    }

    /**
     * Daily cost value
     */
    daily_cost: number;

}
